import api from "../index";
import { apiUrl } from "../../utils/constants";

export const GetStorages = (params) =>
  api.get(apiUrl.storage_plans, { params });
export const GetSingleStorage = (id) =>
  api.get(`${apiUrl.storage_plans}/${id}`);
export const GetStoragePaymentLink = (id) =>
  api.get(`${apiUrl.storage_payment_link}/${id}`);
